import React__default, { useCallback } from 'react';
import { isArray } from 'lodash-es';
import { StyledFormHelperText } from '../InputField/InputField.styles.js';

/* eslint-disable react/no-array-index-key */
var useHandleError = function useHandleError(_ref) {
  var hasError = _ref.hasError,
    noRenderErrorText = _ref.noRenderErrorText,
    errorTextAbsolute = _ref.errorTextAbsolute;
  var renderErrorText = useCallback(function (errorProps) {
    if (noRenderErrorText) {
      return null;
    }
    if (typeof errorProps === 'string') {
      return /*#__PURE__*/React__default.createElement(StyledFormHelperText, {
        errorTextAbsolute: errorTextAbsolute,
        error: hasError
      }, errorProps);
    }
    if (isArray(errorProps)) {
      return errorProps.map(function (msg, index) {
        return /*#__PURE__*/React__default.createElement(StyledFormHelperText, {
          errorTextAbsolute: errorTextAbsolute,
          error: hasError,
          key: index
        }, msg);
      });
    }
    return 'Error';
  }, [hasError, noRenderErrorText, errorTextAbsolute]);
  return {
    renderErrorText: renderErrorText
  };
};
var useHandleError$1 = useHandleError;

export { useHandleError$1 as default };
